export const isDev =
  process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const isDevOrPreview = isDev || isPreview
export const isProduction = !isDevOrPreview
export const environment =
  process.env.NEXT_PUBLIC_PROJECTID === 'doyourtax-prod'
    ? 'production'
    : isDev
    ? 'development'
    : 'staging'

export const TOAST_DURATION = 15000
export const THEME_COLOR = '#00BDAA'
export const MAP_BACKGROUND_COLOR = 'transparent'
export const MAP_COUNTRY_COLOR = '#E0FFF3'

export const DB_USERS = 'customers'
export const DB_SIMULATIONS = 'simulations'
export const DB_PRODUCTS = 'products'
export const DB_PRICES = 'prices'
export const DB_COUNTRIES_CONFIG = 'countriesConfig'

export const STORAGE_PARAMETERS = 'STORAGE_PARAMETERS'
